import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Link, useHistory } from "react-router-dom";
import { FormGroup, Modal, ModalHeader, ModalBody, Label, Button } from "reactstrap";
import { LocalForm, Control } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import SaveButton from "components/common/Forms/SaveButton";
import { Trans, useTranslation } from "react-i18next";
import { useClient } from "hooks";
import Select from "react-select";
import { createPortal } from 'react-dom';

const Login = ({ isAuthenticated }) => {

  const client = useClient();
  const [item, setItem] = useState({ email: "", password: "" });
  const [form, setForm] = useState();

  const [selectedOrganisation, setSelectedOrganisation] = useState(null)
  const [orgList, setOrgList] = useState([])
  const [conntected, setConntected] = useState(isAuthenticated)
  const [type, setType] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [domReady, setDomReady] = React.useState(false)


  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const dir = i18n.dir();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const redirect_uri = params.get('redirect_uri');
  const client_id = params.get('client_id');

  async function onSubmit({ email, password }) {
    try {
      await client.post("/auth", {
        email: email.toLowerCase(),
        password,
      });
      setConntected(true)
      // Launch that app setup

      NotificationManager.success(t("Connected Successfully"));

    } catch (err) {
      if (get(err, "response.status") === 400) {
        NotificationManager.error(t("Invalid username or password"));
      } else {
        NotificationManager.error(t("Unable to log in at this time"));
      }
      err.handled = true;
      throw err;
    }
  }

  const finishSubmit = () => {
    setIsLoading(true)
    if (selectedOrganisation) {
      client.post("/oauth2/code_obtain_url", { org_id: selectedOrganisation, redirect_uri: redirect_uri, client_id: client_id }).then((resp) => {
        const params = resp.data.url
        client.get(`/oauth2/connect/${selectedOrganisation}?${params}`).then((resp) => {
          window.location.href = resp.data.url;
          return
        })
      setIsLoading(false)
      });
    }
  }

  useEffect(() => {
    client.get("/oauth2/app_info", {params:{client_id:client_id}}).then((resp) => {
      setType(resp.data.type)
    }).catch((err) => {
      NotificationManager.error(t('Cannot find an associated application'))
    });

    if (conntected) {
      client.get("/oauth2/orgs_list", {params:{client_id:client_id}}).then((resp) => {

        setOrgList(resp.data)
      });
    }
    setDomReady(true)
  }, [conntected])



  if (!item) return null;
  console.log('is auth', isAuthenticated)

  return (
    <>
    {domReady && isLoading &&
        createPortal(
          <div className="content">
            <div className="loader"></div>
            {/* <p>{text}</p> */}
          </div>,
          document.querySelector('#loader-holder')
        )
      }
    <Modal isOpen={true} size="lg" >
      <ModalHeader className="justify-content-center"><span className="text-center"><Trans>Welcome To Hessab | Login to complete {type} integration</Trans></span></ModalHeader>
      <ModalBody style={{ overflowY: 'visible' }}>
        <div className={`col-sm${dir == "rtl" ? "rtl" : ""} `}>
          {!conntected ?
            <div id="contact-form-1 my-3">
              <h3 className="log-title">
                <Trans>Sign in</Trans>
              </h3>
              <p className="log-text" />
              <LocalForm
                initialState={item}
                onSubmit={onSubmit}
                onChange={setItem}
                onUpdate={setForm}
                className="contactForm"
              >
                <FormGroup style={{ marginBottom: "1rem" }}>
                  <Control.text
                    model=".email"
                    type="email"
                    className="form-control rounded"
                    placeholder={t("Email Address")}
                    required
                  />
                </FormGroup>
                <FormGroup style={{ marginBottom: "1rem" }}>
                  <Control.text
                    model=".password"
                    type="password"
                    className="form-control rounded"
                    placeholder={t("Password")}
                    required
                  />
                </FormGroup>
                {form && (
                  <SaveButton
                    type="submit"
                    id="form-submit"
                    form={form}
                    className="btn-primary-filled btn-rounded btn-form-submit btn-rounded mx-0"
                  >
                    {/* <i className="fa fa-sign-in" aria-hidden="true"></i>  */}
                    <Trans>Sign in</Trans>
                  </SaveButton>

                )}
              </LocalForm>
              <Link className="small" to="/forgotten_password" style={{ textDecoration: "none", color: "#72B566" }}>
                <Trans>Forgotten your password?</Trans>
              </Link><br />
              {/* small form-text text-end */}
              <Link className="small" to="/register" style={{ textDecoration: "none", color: "#121127" }} >
                <Trans>Don’t have an account?</Trans> <span style={{ color: "#72B566" }}><Trans>Create Account</Trans></span>
              </Link>
            </div>
            :
            <div className="my-4 ">
              <h4 className=""><Trans>{type} wants access to:</Trans></h4>
              <div className="py-3">
                <FormGroup className="my-3">
                  <div className="col pl-0">
                    <Label><Trans>Please select an organisation to link with</Trans></Label>
                    <FormGroup>
                      <Select placeholder={t('Select an Organisation')} options={orgList || []} value={selectedOrganisation} onChange={(e) => setSelectedOrganisation(e ? e.value : null)} />
                    </FormGroup>
                  </div>
                </FormGroup>
              </div>
              <Button color="primary ml-0" disabled={selectedOrganisation ? false : true} onClick={finishSubmit}><Trans>Continue with the selected Organisation</Trans></Button>
            </div>
          }
        </div>

      </ModalBody>

    </Modal>
    </>




  );
};

export default Login
